import { render, staticRenderFns } from "./ReservationCalendar.vue?vue&type=template&id=2d526f2b&scoped=true&"
import script from "./ReservationCalendar.vue?vue&type=script&lang=js&"
export * from "./ReservationCalendar.vue?vue&type=script&lang=js&"
import style0 from "./ReservationCalendar.vue?vue&type=style&index=0&id=2d526f2b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d526f2b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VCol,VIcon,VRow,VSelect})
